import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ComboBoxContext } from "./ComboBoxContext";
import { DropdownVirtualItem } from "./DropdownVirtualItem";
import { ADD_NEW, NO_RECORD, SEPERATOR, SEPERATOR_HEIGHT } from "./Constants";
import { List } from "@ajayvikas/react-list";
import cls from "./combo-box.module.scss";
export const DropdownVirtualList = ({ flatDataSource: dataSource, renderItem, textField, valueField, itemHeight, onAddNew, addNewElement }) => {
    const virtualList = React.useRef(null);
    const { subscribe, getHighlightSource, getHighlightedindex, seperatorClass, seperatorStyle, addNewClass, addNewStyle, noRecordClass, noRecordStyle } = React.useContext(ComboBoxContext);
    const itemSizeFn = React.useCallback((index) => {
        return dataSource[index] === SEPERATOR ? SEPERATOR_HEIGHT : itemHeight;
    }, [dataSource, itemHeight]);
    const rowRenderer = ({ style, rowIndex: index, attributes }) => {
        const item = dataSource[index];
        if (item === SEPERATOR) {
            return _jsx("div", { className: seperatorClass ?? cls.seperator, style: { ...style, ...seperatorStyle, height: SEPERATOR_HEIGHT }, ...attributes, children: _jsx("hr", {}) }, index);
        }
        else if (item === ADD_NEW) {
            if (!onAddNew)
                throw new Error("onAddNew must be provided");
            return _jsx("div", { onMouseDown: e => onAddNew(), className: addNewClass ?? cls.addNew, style: { ...style, ...addNewStyle }, children: addNewElement ?? _jsx("div", { children: "From Code" }) }, index);
        }
        else if (item === NO_RECORD) {
            return _jsx("div", { className: noRecordClass ?? cls.noRecord, style: { ...style, ...noRecordStyle }, children: _jsx("div", { children: "No Record Found" }) }, index);
        }
        return _jsx(DropdownVirtualItem, { item: item, index: index, textField: textField, valueField: valueField, renderItem: renderItem, style: style, itemHeight: itemHeight }, index);
    };
    const highlightSource = React.useSyncExternalStore(subscribe, () => getHighlightSource());
    const highlightIndex = React.useSyncExternalStore(subscribe, () => getHighlightedindex());
    React.useEffect(() => {
        if (highlightSource === "m")
            return;
        requestAnimationFrame(() => {
            virtualList.current?.scrollToIndex(highlightIndex);
        });
    }, [highlightIndex, highlightSource]);
    return _jsx(List, { infiniteLoad: false, ref: virtualList, itemHeight: itemSizeFn, itemCount: dataSource.length, itemRenderer: rowRenderer });
};
